export default "__VITE_ASSET__Ae79ZTfn__"